exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "\n.v-card[data-v-0d48a61a] {\n    padding: 20px 25px 25px 25px;\n}\n.server-info[data-v-0d48a61a] {\n    margin-top: 15px;\n    text-align: center;\n}\n", ""]);

